import Vue from "vue";
import VueRouter from "vue-router";
import GlobalGuards from "@/guards/Global";
import label from "@/lang/StaticLabels.js";

import TheContainer from "@/containers/TheContainer";
import TheContainerLogin from "@/containers/TheContainerLogin";
const Page404 = () => import("@/views/errors/Page404");
const Page403 = () => import("@/views/errors/Page403");
const Page500 = () => import("@/views/errors/Page500");
const PageUnderConstruction = () =>
  import("@/views/errors/PageUnderConstruction");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Container",
    component: TheContainer,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "Home",
        meta: {
          label: label.page.dashboard,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/Home"),
      },
      {
        path: "profile",
        name: "Profile",
        meta: {
          label: label.page.profile,
          requiresAuth: false,
        },
        component: () => import("@/views/auth/Profile"),
      },
      {
        path: "base",
        name: "BaseInformations",
        meta: {
          label: label.page.baseInformation,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/base"),
      },
      {
        path: "users",
        name: "Users",
        meta: {
          label: label.page.users,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/users"),
      },
      {
        path: "aboutUs",
        name: "About",
        meta: {
          label: label.page.aboutUs,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/other/AboutView"),
      },
      {
        path: "contactUs",
        name: "Contact",
        meta: {
          label: label.page.contactUs,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/other/ContactView"),
      },
      {
        path: "faq",
        name: "Faq",
        meta: {
          label: label.page.faq,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/other/FaqView"),
      },
      {
        path: "rules",
        name: "Rules",
        meta: {
          label: label.page.rules,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/other/Rules"),
      },
      {
        path: "service/:id",
        name: "ServiceDetail",
        meta: {
          label: label.page.services,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/services"),
      },
      {
        path: "product",
        name: "Product",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/product/list",
        children: [
          {
            path: "list",
            name: "ProductList",
            component: () => import("@/views/pages/products/List"),
            meta: {
              label: label.page.products,
              requiresAuth: false,
            },
          },
          {
            path: "details/:id",
            name: "ProductDetails",
            component: () => import("@/views/pages/products/Details"),
            meta: {
              label: label.page.productDetails,
              requiresAuth: false,
            },
          },
        ],
      },
      {
        path: "blog",
        name: "Blog",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/blog/list",
        children: [
          {
            path: "list",
            name: "BlogList",
            component: () => import("@/views/pages/blog/List"),
            meta: {
              label: label.page.blog,
              requiresAuth: false,
            },
          },
          {
            path: "details/:id/:title",
            name: "BlogDetails",
            component: () => import("@/views/pages/blog/Details"),
            meta: {
              label: label.page.blogDetails,
              requiresAuth: false,
            },
          },
        ],
      },
      {
        path: "orders",
        name: "Orders",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/orders/add",
        children: [
          {
            path: "add",
            name: "AddOrder",
            component: () => import("@/views/pages/orders/Add"),
            meta: {
              label: label.page.addOrder,
              requiresAuth: false,
            },
          },
        ],
      },
      {
        path: "rejected",
        name: "RejectedTemplate",
        meta: {
          label: label.page.noAccess,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/RejectedTemplate"),
      },
      {
        path: "/page",
        redirect: "/page/list",
        name: "Page",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: ":key",
            name: "DynamicPage",
            component: () => import("@/views/pages/other/DynamicPage"),
          },
        ],
      },
    ],
  },

  {
    path: "/login",
    name: "UserLogin",
    component: TheContainerLogin,
    redirect: "/user/login",
    children: [
      {
        path: "/login",
        name: "Login",
        meta: {
          label: label.page.login,
        },
        component: () => import("@/views/auth/Login"),
        beforeEnter(to, from, next) {
          GlobalGuards.login(to, from, next);
        },
      },
      {
        path: "/register",
        name: "Register",
        meta: {
          label: label.page.register,
        },
        component: () => import("@/views/auth/Register"),
        beforeEnter(to, from, next) {
          GlobalGuards.login(to, from, next);
        },
      },
      {
        path: "/panel",
        name: "UserPanel",
        redirect: "/panel/dashboard",
        component: () => import("@/containers/PanelSidebar"),
        children: [
          {
            path: "dashboard",
            name: "PanelDashboard",
            meta: {
              label: label.page.dashboard,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/panel/Dashboard"),
          },
          {
            path: "profile",
            name: "UserProfile",
            meta: {
              label: label.page.profileSetting,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/panel/profile/index"),
          },
          {
            path: "orders",
            name: "UserOrders",
            meta: {
              label: label.page.orders,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/panel/Orders"),
          },
          {
            path: "orders/:id",
            name: "OrderDetails",
            meta: {
              label: label.page.orderDetails,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/panel/OrderDetails"),
          },
          {
            path: "favorites",
            name: "Favorites",
            meta: {
              label: label.page.favorites,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/panel/Favorites"),
          },
          {
            path: "returns",
            name: "Returns",
            meta: {
              label: label.page.returns,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/panel/Returns"),
          },
          {
            path: "tickets",
            name: "Tickets",
            meta: {
              label: label.page.tickets,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/panel/Tickets"),
          },
          {
            path: "cart",
            name: "UserCart",
            meta: {
              label: "سبد خرید",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/panel/cart"),
          },
        ],
      },

      {
        path: "/payment/result/:factorId",
        name: "PaymentResult",
        meta: {
          label: "نتیجه پرداخت",
          requiresAuth: false,
        },
        component: () => import("@/views/pages/panel/PaymentResult"),
      },

    ],
  },
  // other Pages - without container

  {
    path: "/pages",
    redirect: "/pages/404",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
      {
        path: "403",
        name: "Page403",
        component: Page403,
      },
      {
        path: "500",
        name: "Page500",
        component: Page500,
      },
      {
        path: "underConstruction",
        name: "PageUnderConstruction",
        component: PageUnderConstruction,
      },
    ],
  },

  {
    path: "*",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

router.beforeEach((to, from, next) => GlobalGuards.beforeEach(to, from, next));
router.afterEach((to, from) => GlobalGuards.afterEach(to, from));

export default router;
